module.exports = __webpack_public_path__ + "img/892-8c0660.png";